type Props = {
  currentBlock: any;
};

const TextField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <div className="tiptap-text">
      <div dangerouslySetInnerHTML={{ __html: label }}></div>
    </div>
  );
};
export default TextField;
